import React from 'react'
import TrackingPage from './TrackingPage'

export default TrackingPage
